// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#form-wrapper[data-v-ec9c1c44]{display:flex}form[data-v-ec9c1c44]{padding:20px;background-color:#eee}label[data-v-ec9c1c44]{margin-bottom:0;font-size:.9rem}div.v-input[data-v-ec9c1c44]{padding-top:0;padding-bottom:10px}#submit-button[data-v-ec9c1c44]{width:100%}", ""]);
// Exports
module.exports = exports;
